// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"252119b5","453":"d95facbe","455":"da8c5595","977":"77722b9f"}[chunkId] + ".chunk.js";
};